import React, { useState, useEffect } from "react";
// 1. useLocation ko import karein
import { useNavigate, useLocation } from "react-router-dom";
import Button from "../ui/Button";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  // 2. location object get karein
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    const event = new CustomEvent("menuStateChange", { detail: menuOpen });
    window.dispatchEvent(event);
  }, [menuOpen]);

  const handleNavigation = (path) => {
    navigate(path);
    closeMenu();
  };

  // Menu Items Array
  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Products", path: "/products" },
    { name: "Press Release", path: "/press-release-gallery" },
    { name: "Utpann Network", path: "/utpann-network" },
    { name: "Blog", path: "https://blog.utpann.in/" },
    { name: "Contact Us", path: "/contact-us" },
  ];

  return (
    <header className="w-full relative z-50">
      <div className="w-full max-w-[1620px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 lg:py-6">
          {/* Menu Trigger (Desktop Left) */}
          <button
            className="hidden xl:block p-2 flex-none xl:w-[190px] cursor-pointer"
            aria-label="Open menu"
            onClick={() => setMenuOpen(true)}
          >
            <img
              src="/assets/menuIcon.png"
              alt="Menu Icon"
              className="w-8 h-auto"
            />
          </button>

          {/* Logo */}
          <div className="flex-1 flex justify-start xl:justify-center">
            <button onClick={() => navigate("/")} className="cursor-pointer">
              <img
                src="/assets/headerLogo.png"
                alt="Logo"
                className="w-[140px] h-[56px] md:w-[165px] md:h-[66px] lg:w-[190px] lg:h-[76px]"
              />
            </button>
          </div>

          {/* Contact Us Button - Header (Isse bhi hide karna ho toh condition laga sakte hain) */}
          <div className="hidden xl:block">
            {location.pathname !== "/contact-us" && (
              <Button
                text="Contact Us"
                onClick={() => navigate("/contact-us")}
                className="px-8 py-3 border border-[#343163] rounded-xl font-semibold text-[#343163] hover:bg-[#343163] hover:text-white transition-all duration-300"
              />
            )}
          </div>

          {/* Menu Trigger (Mobile Right) */}
          <button
            className="block xl:hidden p-2 flex-none"
            onClick={() => setMenuOpen(true)}
          >
            <img
              src="/assets/menuIcon.png"
              alt="Menu Icon"
              className="w-8 h-auto"
            />
          </button>
        </div>
      </div>

      {/* --- FULL SCREEN OVERLAY MENU --- */}
      <div
        className={`fixed inset-0 bg-[#343163] text-white z-[9999] transition-all duration-500 ease-in-out ${
          menuOpen
            ? "opacity-100 visible"
            : "opacity-0 invisible pointer-events-none"
        }`}
      >
        <button
          className="absolute top-8 right-8 text-white p-2 hover:rotate-90 transition-transform duration-300"
          onClick={closeMenu}
        >
          <svg
            className="w-10 h-10"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="h-full flex flex-col justify-center items-center px-6 ">
          <nav className="flex flex-col items-center space-y-2 lg:space-y-8 mb-12">
            {navLinks
              // 3. Filter apply kiya: Agar path contact-us hai toh 'Contact' link skip karein
              .filter((link) => {
                // if (
                //   location.pathname === "/contact-us" &&
                //   link.path === "/contact-us"
                // ) {
                //   return false;
                // }
                return true;
              })
              .map((link, index) => (
                <button
                  key={link.name}
                  onClick={() => handleNavigation(link.path)}
                  className={`text-[24px] lg:text-[40px] font-bold transition-all duration-300 hover:text-gray-300 transform ${
                    menuOpen
                      ? "translate-y-0 opacity-100"
                      : "translate-y-10 opacity-0"
                  }`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  {link.name}
                </button>
              ))}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
